import React from "react"
import { BriefcaseIcon } from "../svg"
import { Link } from "react-router-dom"

function ContactSection() {
	return (
		<div className="contact">
			<div className="contact__left">
				<BriefcaseIcon />

				<p>IDEEA TA CONTEAZA</p>
			</div>

			<Link to="/contact">CONTACTEAZA-NE</Link>
		</div>
	)
}

export default ContactSection
